import type {
  ConversationClientContext,
  ConversationMetadata,
} from "@mirage/service-conversation/types";
import { v5 as uuidv5 } from "uuid";

const RECENT_CHATS_NAMESPACE = "3d4b929e-d682-417e-a2b8-290163f126a0";

export type RecentChat = Pick<
  ConversationMetadata,
  "serverConversationId" | "title" | "clientContext"
> & {
  uuid: string;
};

export function conversationToRecentChat(conversation: {
  serverConversationId: string;
  title: string;
  clientContext?: ConversationClientContext;
}): RecentChat {
  return {
    uuid: uuidv5(conversation.serverConversationId, RECENT_CHATS_NAMESPACE),
    title: cleanTitle(conversation.title),
    serverConversationId: conversation.serverConversationId,
    clientContext: conversation?.clientContext,
  };
}

export function deduplicateRecentChats(chats: RecentChat[]): RecentChat[] {
  const set = new Set<string>();

  return chats.filter((chat) => {
    if (set.has(chat.title)) return false;
    set.add(chat.title);
    return true;
  });
}

export function cleanTitle(originalTitle: string) {
  return originalTitle.replace(/^#+\s+/, "").trim();
}

// We want to filter out the conversations created by the answers panel on the SERP page
// NOTE: we're doing a deny list approach instead of an allow list since there's some trickier scenarios
// in chat where we don't want to override the original client context with a follow-up & overwrite previous scenario
export function filterChatsWithValidClientContext(chats: RecentChat[]) {
  return chats.filter((chat) => isValidOmniboxRecentChat(chat));
}

export const isValidOmniboxRecentChat = (
  chat: RecentChat | ConversationMetadata,
) => chat.clientContext && chat.clientContext.clientScenario !== "serp-answer";
